import { debug } from "../utils";

export const ACTION_USERS_LOADED = "ACTION_USERS_LOADED";
export const ACTION_SHOW_MODAL = "ACTION_SHOW_MODAL";

export const ACTION_AUTHSERVERS_LOADED = "ACTION_AUTHSERVERS_LOADED";
export const ACTION_CENTRALCREDENTIALS_LOADED = "ACTION_CENTRALCREDENTIALS_LOADED";

export function AuthPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_USERS_LOADED: {
            debug(`AuthPageReducer ${ACTION_USERS_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_SHOW_MODAL: {
            debug(`AuthPageReducer ${ACTION_SHOW_MODAL} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_AUTHSERVERS_LOADED: {
            debug(`AuthPageReducer ${ACTION_AUTHSERVERS_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_CENTRALCREDENTIALS_LOADED: {
            debug(`AuthPageReducer ${ACTION_CENTRALCREDENTIALS_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}